var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-btn',{attrs:{"color":"primary","small":"","text":"","to":"/cancel-sale"}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("mdi-keyboard-backspace")]),_vm._v("Back ")],1),_c('editor',{attrs:{"initial":_vm.dataItem},on:{"data":_vm.save}}),_c('snackbar',{ref:"snackbar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }